import {EventEmitter} from 'eventemitter3'

export const systemConfigurationEvent = new EventEmitter()

export const systemConfigurationTypes = {
    ADDITIONAL_METHOD_CHANGE: 'ADDITIONAL_METHOD_CHANGE',
}

export function getSystemConfigurationEventKey(eventType) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case systemConfigurationTypes.ADDITIONAL_METHOD_CHANGE:
            return `ADDITIONAL_METHOD_CHANGE`

        default:
            return ''
    }
}

export function onSystemConfigurationChangeListener(
    eventType = systemConfigurationTypes.ADDITIONAL_METHOD_CHANGE,
    data,
) {
    systemConfigurationEvent.emit(
        getSystemConfigurationEventKey(eventType),
        data,
    )
}

export function onSystemConfigurationChangeRemoveListener(
    eventType = systemConfigurationTypes.ADDITIONAL_METHOD_CHANGE,
) {
    systemConfigurationEvent.removeListener(
        getSystemConfigurationEventKey(eventType),
    )
}
